import React, { useEffect, useState } from "react";
import {
  Container,
  Form,
  Navbar,
  Offcanvas,
  Row,
  Nav,
  NavDropdown,
} from "react-bootstrap";
import { NavLink } from "react-router-dom";
import starizen_logo1 from "../../../assets/images/starizen_logo1.png";
import starizen_logo2 from "../../../assets/images/starizen_logo2.png";
import instagram_btn from "../../../assets/images/icons/instagram_btn.png";

import "../header/header.css";
import { websiteData } from "../../../utils/data";

// https://react-bootstrap.netlify.app/docs/components/navbar#offcanvas

const Header = () => {
  const [open, setOpen] = useState(false);

  // const [logo, setLogo] = useState(starizen_logo1);
  const [isStickyHeader, setIsStickyHeader] = useState(false);

  const toggleMenu = () => {
    setOpen(!open);
  };

  // sticky header
  const isSticky = (e) => {
    const header = document.querySelector(".header-section");
    const scrollTop = window.scrollY;
    scrollTop >= 120
      ? header.classList.add("is-sticky")
      : header.classList.remove("is-sticky");

    setIsStickyHeader(window.scrollY >= 120);
    /*  if (window.scrollY >= 120) {
      header.classList.add("is-sticky");
      // swap logo
      header.querySelector("img.business_logo").src = starizen_logo2;
    } else {
      header.classList.remove("is-sticky");
      header.querySelector("img.business_logo").src = starizen_logo1;
    } */
  };

  useEffect(() => {
    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  });

  const closeMenu = () => {
    if (window.innerWidth <= 991) {
      setOpen(false);
    }
  };
  return (
    <header className="header-section">
      <Container>
        <Navbar expand={"lg"} className=" p-0">
          {/* Logo Section */}
          <Navbar.Brand>
            <NavLink className="nav-link" to={"/"}>
              <img
                src={isStickyHeader ? starizen_logo2 : starizen_logo1}
                className="img-fluid business_logo"
              />
            </NavLink>
          </Navbar.Brand>
          {/* End Logo Section */}
          {/* <Navbar.Toggle aria-controls={"offcanvasNavbar-expand-lg"} /> */}

          <Navbar.Offcanvas
            id={"offcanvasNavbar-expand-lg"}
            aria-labelledby={"offcnvasNavbarLabel-expand-lg"}
            placement="start"
            show={open}
          >
            {/* Mobile logo section */}
            <Offcanvas.Header>
              {/* <Offcanvas.Header closeButton> */}
              {/*  <Offcanvas.Title id={"offcanvasNavbarLabel-expand-lg"}>
                    STARIZEN STUDIOS
                  </Offcanvas.Title> */}
              <h1 className="logo">{websiteData.company_name}</h1>
              <span className="navbar-toggler ms-auto" onClick={toggleMenu}>
                <i className="bi bi-x-lg"></i>
              </span>
            </Offcanvas.Header>
            {/* end Mobile logo section */}

            <Offcanvas.Body>
              <Nav className="justify-content-end flex-grow-1 pe-3">
                <NavLink className="nav-link" to={"/"} onClick={closeMenu}>
                  Home
                </NavLink>
                <NavLink
                  className="nav-link"
                  to="/about-us"
                  onClick={closeMenu}
                >
                  About Us
                </NavLink>

                <NavLink
                  className="nav-link"
                  to="/portfolio"
                  onClick={closeMenu}
                >
                  Portfolio
                </NavLink>
                {/* <NavDropdown
                  title="Destination"
                  id={"offcanvasNavbarDropdown-expand-lg"}
                >
                  <NavDropdown.Item href="#action3">
                    Italy Tours
                  </NavDropdown.Item>
                  <NavDropdown.Item href="#action4">
                    Spain Tours
                  </NavDropdown.Item>
                  <NavDropdown.Item href="#action5">
                    France Tours
                  </NavDropdown.Item>
                </NavDropdown> */}

                <NavLink className="nav-link" to="/gallery" onClick={closeMenu}>
                  Gallery
                </NavLink>
                <NavLink
                  className="nav-link"
                  to="/contact-us"
                  onClick={closeMenu}
                >
                  Contact
                </NavLink>
              </Nav>
            </Offcanvas.Body>
          </Navbar.Offcanvas>

          <div className="ms-md-4 ms-2">
            <a
              target="_blank"
              href={`${websiteData.instagram}`}
              className={" d-none d-sm-inline-block"}
            >
              <img src={instagram_btn} className="img-fluid insta_image" />
            </a>
            <li className="d-inline-block d-lg-none ms-3 toggle_btn">
              <i
                className={open ? "bi bi-x-lg" : "bi bi-list"}
                onClick={toggleMenu}
              ></i>
            </li>
          </div>
        </Navbar>
      </Container>
    </header>
  );
};

export default Header;
